import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth-service/auth.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OAuthService);
  const authService = inject(AuthService);
  const notificationService = inject(NotificationService);

  const accessToken = oauthService.getAccessToken();
  const clonedReq = accessToken
    ? req.clone({
        headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
      })
    : req;

  return next(clonedReq).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        notificationService.showErrorMessage('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
        authService.logout();
      }
      return throwError(() => error);
    }),
  );
};
